import { useApp } from "Providers/AppProvider";
import { useRef } from "react";

export function isIpadOs() {
	if (/iPad/.test(navigator.platform)) {
		return true;
	} else {
		return /MacIntel/.test(navigator.platform) && navigator.maxTouchPoints > 2;
	}
}

export function isDesktopSafari() {
	return (
		/Safari/i.test(navigator.userAgent) &&
		/Apple Computer/.test(navigator.vendor) &&
		!/Mobi|Android/i.test(navigator.userAgent)
	);
}

export function useIsBrowserOrIpadOs() {
	const { isNative } = useApp();
	const isIpadOsRef = useRef(isIpadOs());

	if (isNative) {
		return isIpadOsRef.current;
	} else {
		return true;
	}
}
